/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Box, Stack, Typography, Card, useTheme } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import InsightDebtorsTable from '@/components/tables/InsightDebtorsTable';

export const InsightPolicyTransactionTab = () => {
	const theme = useTheme();

	const { clientRow } = useObjectContext();

	const { getFeatureFlags } = useFeatureFlagContext();
	const showDisplayPolicies = Boolean(getFeatureFlags('displayClientPolicies')?.active);

	return showDisplayPolicies ? (
		<Box
			sx={{
				'& .MuiDataGrid-parentDiv': {
					border: `1px solid ${theme.palette.divider}`,
					borderRadius: '8px',
					backgroundColor: theme.palette.background.paper,
				},
				'& .MuiDataGrid-root': {
					borderRadius: '8px',
				},
			}}
		>
			<InsightDebtorsTable
				clientId={clientRow?.insightId}
				sortByEffectiveDate={true}
				displayCheckBoxes={false}
				columnType='client'
				displayTransactionFilter={true}
			/>
		</Box>
	) : (
		<Stack p={3}>
			<Box px={'1em'}>
				<Typography>{'Policies tab coming soon.'}</Typography>
			</Box>
		</Stack>
	);
};
InsightPolicyTransactionTab.displayName = 'InsightPolicyTransactionTab';
